import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Fri Jul 27 2018
 * @author BPo
 */
import { debugEnabled } from './debugEnabled';
var LogType;

(function (LogType) {
  LogType["info"] = "info";
  LogType["warn"] = "warn";
  LogType["error"] = "error";
})(LogType || (LogType = {}));
/**
 * Lightweight JavaScript logger.
 */


var Logger =
/*#__PURE__*/
function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.enabled = debugEnabled();
    this.log = [];
  }
  /**
   * Log message to the console when debug argument is passed
   * @param {LogType} type of the logging message
   * @param {any[]} args Arguments to log
   */


  _createClass(Logger, [{
    key: "invoke",
    value: function invoke(type, args) {
      var timestamp = Date.now();
      this.log.push({
        message: args,
        timestamp: timestamp,
        type: type
      });

      if (this.enabled) {
        var _console;

        (_console = console)[type].apply(_console, ["[LOG ".concat(timestamp, "]")].concat(_toConsumableArray(args)));
      }
    }
    /**
     * The log can also be returned even if the logging mode is not turned on.
     */

  }, {
    key: "getLogs",
    value: function getLogs() {
      return this.log;
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.invoke(LogType.info, args);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.invoke(LogType.warn, args);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.invoke(LogType.error, args);
    }
  }]);

  return Logger;
}();

export default new Logger();